import { render, staticRenderFns } from "./SubdomainsTable.vue?vue&type=template&id=4adaa533&"
import script from "./SubdomainsTable.vue?vue&type=script&lang=js&"
export * from "./SubdomainsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adaa533')) {
      api.createRecord('4adaa533', component.options)
    } else {
      api.reload('4adaa533', component.options)
    }
    module.hot.accept("./SubdomainsTable.vue?vue&type=template&id=4adaa533&", function () {
      api.rerender('4adaa533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/SubDomains/SubdomainsTable.vue"
export default component.exports